import { Typography } from 'antd';
import { IFAQCoordinatorPost } from 'interfaces/faq_coordinators';
import { formatDate } from 'services/date';
import { styled } from '@qcx/ui';

export interface PostProps {
  post: IFAQCoordinatorPost;
}

export const Post = ({ post }: PostProps) => {
  const authorName =
    post.author_type === 'User'
      ? post.author?.full_name_or_name ?? post.author?.name
      : post.author?.name;

  return (
    <div className="w-full py-4">
      <div className="text-sm text-neutral-500">
        <div className="font-medium text-neutral-700">{authorName}</div>
        <div>
          {formatDate(
            post.updated_at ?? post.created_at,
            'DD/MM/YYYY à[s] HH:mm'
          )}
        </div>
      </div>
      <StyledParagraph className="mt-2 !mb-0">{post.text}</StyledParagraph>
    </div>
  );
};

const StyledParagraph = styled(Typography.Paragraph, {
  whiteSpace: 'pre-line'
});
